export interface Salary_Interface {
    id:number,
    year:number,
    bonKargari:number,
    maskan:number,
    kharbar:number,
    tahahol:number,
    farzand:number,
    payeh:number,
    paziraee:number,
}


export function Empty_Salary_Interface():Salary_Interface{
  return{
    id:0,
    year:0,
    bonKargari:0,
    maskan:0,
    kharbar:0,
    tahahol:0,
    payeh:0,    
    farzand:0,    
    paziraee:0,    
  }
}